// extracted by mini-css-extract-plugin
export default {"root":"pRe1t1fmNsSdynZJBjxu"};